import { render, staticRenderFns } from "./ItemClassSelectMulti.vue?vue&type=template&id=4d5f3e9c&"
import script from "./ItemClassSelectMulti.vue?vue&type=script&lang=js&"
export * from "./ItemClassSelectMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports